import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.item',
            buyables: null
        }
    },

    methods: {
        allBuyables() {
            if(this.buyables) {
                return Promise.resolve(this.buyables)
            }

            return axios({
                method: 'get',
                url: route('api.items.all.buyables')
            })
            .then(response => {
                this.$set(this, 'buyables', response.data.data)
                return this.buyables
            })
        }
    }
}